export const MainLayoutViewClassName = "kahun-main-layout-view";
